/*
 *  ___                  __                __  _ _
 *   | |_  _     _ |_ |_|_    _  _ _ _ _  /  \(_(_|. _  _
 *   | | )(_)|_|(_)| )|_|__)(|_)| (-_)_)  \__/| | ||| )(-
 *              _/           |
 */

export const form = {
  'selected-premium': {
    'monthly-contribution': null,
    'cash-bonus-premium': null,
    'hospitalisation-cover-option': null,
    'update-option': null,
    'lumpsum-contribution': null,
  },
  'cover-level': {
    'low-cover': null,
    'medium-cover': null,
    'high-cover': null,
  },
  'life-assured-identification': {
    'first-names': null,
    surname: null,
    'date-of-birth': null,
    'idpassport-number': null,
    'id-type': null,
    title: null,
    'marital-status': null,
    nationality: null,
    gender: null,
  },
  'life-assured-contact-details': {
    'cell-phone': null,
    'work-phone': null,
    'home-phone': null,
    fax: null,
    email: null,
  },
  'life-assured-postal-address': {
    addressee: null,
    'po-box-or-private-bag': null,
    'area-code': null,
    street: null,
    suburb: null,
    town: null,
    region: null,
  },
  'life-assured-employment-details': {
    occupation: null,
  },
  'spouse-identification': {
    'first-names': null,
    surname: null,
    'date-of-birth': null,
    'idpassport-number': null,
    'id-type': null,
    'marital-status': null,
    title: null,
    gender: null,
  },
  'spouse-contact-details': {
    'cell-phone': null,
    'work-phone': null,
    'home-phone': null,
  },
  'spouse-is-trustee': null,
  'trustee-identification': {
    'first-names': null,
    surname: null,
    'date-of-birth': null,
    'idpassport-number': null,
    'id-type': null,
    'marital-status': null,
    title: null,
    gender: null,
  },
  'trustee-contact-details': {
    'cell-phone': null,
    'work-phone': null,
    'home-phone': null,
  },
  'beneficiary-details': [],
  'life-assured-health-details': {
    'presently-in-good-health': null,
    'risky-occupation-hobbies': null,
    'taking-prescriptions': null,
    'sexually-transmitted-diseases': null,
    'refused-application-or-increased-premium': null,
    'hereditary-diseases': null,
    'height-in-cm': null,
    'weight-in-kg': null,
    'weight-change': null,
    'beers-per-week': null,
    'wine-per-week': null,
    'total-weekly-spirits': null,
    'alcohol-past-consumption': null,
    smoker: null,
    'smoking-per-day': null,
    'smoking-preference': null,
  },
  'health-concerns': [],
  'payment-method-selection': {
    'debit-order': null,
    'stop-order': null,
  },
  'payment-start-date': null,
  'payer-person-identification': {
    'first-names': null,
    surname: null,
    'date-of-birth': null,
    'idpassport-number': null,
    'id-type': null,
  },
  'payment-bank-details': {
    'account-holder-name': null,
    'account-type': null,
    'account-entity-name': null,
    'account-branch-name': null,
    'account-number': null,
  },
  'payment-employment-details': {
    'employer-organisation': null,
    'employee-number': null,
  },
  'forces-pay-office-details': {
    'policy-name': 'Lifetime Needs Plus',
    'company-name': null,
    'branch-name': null,
    date: null,
    'representative-name': null,
    'telephone-number': null,
    'ecowas-id-number': null,
    'svc-number': null,
    'armed-forces-rank': null,
    unit: null,
  },
  'life-assured-is-payer': null,
  'payer-person': {
    myself: null,
    'my-spouse': null,
  },
  'payer-signature': null,
  documents: {
    'id-document': [],
    'passport-document': [],
    'service-certificate-document': [],
  },
  'acceptance-signature': null,
  'application-acceptance-date': null,
  'application-accepted': null,
}
